import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
export default store => ({
  path: Routes.ticket.child.viewProgress.key,
  onEnter(nextState, replace, callback) {
    if (window.sessionStorage.getItem('first')) {
      window.location.reload();
      window.sessionStorage.removeItem('first');
    }
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const ViewProgress = require('./components/viewProgress').default;
        cb(null, ViewProgress);
      },
      'ViewProgress'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/viewProgress/index.js